module.exports = __webpack_public_path__ + "static/img/hero2.8ff369a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hero2.png
// module id = RNMt
// module chunks = 1